import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@app/modules/organization/areas-table/form/form.component';

@Component({
  selector: 'app-confirm-model-finalize',
  templateUrl: './confirm-model-finalize.component.html',
  styleUrls: ['./confirm-model-finalize.component.scss']
})
export class ConfirmModelFinalizeComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmModelFinalizeComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngOnInit(): void {
  }

}
